// General
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

// GraphQL
import { flowRight as compose } from 'lodash';

// Redux
import { connect } from 'react-redux';

// Translation
import { useIntl, FormattedMessage } from 'react-intl';
import cx from 'classnames';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import {
	Grid,
	Button,
	Row,
	Col,
} from 'react-bootstrap';

// Components
import Loader from '../../../components/Loader';
import Link from '../../Link';
import WishListGroupModal from '../WishListGroupModal';
import NotFound from '../../../routes/notFound/NotFound';
import ListingItem from '../ListingItem'

// GraphQL
import { getWishListGroupQuery } from '../../../lib/graphql';
// Locale
import messages from '../../../locale/jsonMessages';

import { openAddWishListGroupModal, closeWishListModal } from '../../../actions/WishList/modalActions';
import { deleteWishListGroup } from '../../../actions/WishList/deleteWishListGroup';

//Images
import goListIcon from '/public/AdminIcons/whistListGoIcon.svg';
import editIcon from '/public/AdminIcons/whistListEditIcon.svg';
import deleteIcon from '/public/AdminIcons/whistListDeleteIcon.svg';
import noImage from '/public/siteImages/noWishList.svg';

import { withQuery } from '../../../hoc/withGraphql';

import cs from '../../../components/commonStyle.css';
import s from './EditWishListGroup.css';

function EditWishListComponent(props) {

	const { profileId, wishListId, wishListLoading, locale, dynamicLanguageData, dynamicTitle } = props;
	const { data: { loading, getWishListGroup } } = props;
	const { formatMessage } = useIntl();
	const { openAddWishListGroupModal, deleteWishListGroup } = props;
	const [listingData, setListData] = useState([]);
	const [actionType, setActionType] = useState('');

	let initialValues = {};

	useEffect(() => {
		let listingData = [];
		if (getWishListGroup?.wishLists && getWishListGroup?.wishLists.length > 0) {
			getWishListGroup?.wishLists.map((item) => {
				if (item.listData) listingData.push(item.listData)
			})
		}
		setListData(listingData)

	})
	const openEditWishListModal = (initialValues, actionType) => {
		setActionType(actionType)
		openAddWishListGroupModal(initialValues, 'EditWishListGroupForm')
		var root = document.getElementsByTagName('html')[0];
		root.classList.add('scrollHidden');
	}

	if (getWishListGroup && getWishListGroup.id) {
		initialValues = {
			id: getWishListGroup.id,
			name: getWishListGroup.name,
			isPublic: Number(getWishListGroup.isPublic),
			userId: getWishListGroup.userId
		};
	}

	if (getWishListGroup === null) {
		return <NotFound />
	}

	return (
		<div>
			<WishListGroupModal actionType={actionType} wishListGroupId={getWishListGroup?.id} />
			<Grid fluid className={cs.commonContainerList}>
				<Row>
					{
						(loading || wishListLoading) && <Col xs={12} sm={12} md={12} lg={12}>
							<Loader type="text" />
						</Col>
					}
					{
						!loading && getWishListGroup && !wishListLoading && <Col xs={12} sm={12} md={12} lg={12}>
							<div className={cx(cs.dFlexContainer, cs.spaceBottom5, s.flexWrapMb)}>
								<Link to={"/wishlists"} className={cx(cs.btnPrimaryBorder)}>
									<img src={goListIcon} className={cx('commonIconSpace', 'goArrowRTL')} />
									<span className={'vtrMiddle'}>{formatMessage(messages.goToAllLists)}</span>
								</Link>
								<div className={cx(cs.dFlexContainer)}>
									<Button className={cx(cs.btnPrimary, s.editBtnMargin)}
										onClick={() => openEditWishListModal(initialValues, 'edit')}>
										<img src={editIcon} className={cx('commonIconSpace', s.iconWidth)} />
										<span className={'vtrMiddle'}><FormattedMessage {...messages.editLabel} /></span>
									</Button>

									<Button className={cx(cs.btnPrimary)}
										onClick={() => openEditWishListModal(initialValues, 'delete')}>
										<img src={deleteIcon} className={cx('commonIconSpace', s.iconDeleteWidth)} />
										<span className={'vtrMiddle'}><FormattedMessage {...messages.delete} /></span>
									</Button>
								</div>
							</div>
							<h2 className={cx(cs.commonTitleText, cs.fontWeightBold, cs.paddingBottom4)}>
								{
									getWishListGroup.name
								}
							</h2>
							{
								!loading && getWishListGroup && !wishListLoading && <div className={s.listGrid}>
									{listingData && listingData.length > 0 && <ListingItem data={listingData} fromPage={'whistList'} isEditWishList locale={locale} dynamicLanguageData={dynamicLanguageData} dynamicTitle={dynamicTitle} />}
								</div>
							}
							{
								listingData?.length == 0 &&
								<div className={s.noWishList}>
									<img src={noImage} />
									<h6 className={cx(cs.commonMediumText, cs.paddingBottom5, cs.paddingTop5)}>{formatMessage(messages.noWishlistsHomes)}</h6>
									<Link to={"/s"} className={cx(cs.btnPrimary)}>
										<span className={'vtrMiddle'}>{formatMessage(messages.startExplore)}</span>
									</Link>
								</div>
							}
						</Col>
					}
				</Row>
			</Grid>
		</div>
	)
}

const mapState = (state) => ({
	wishListLoading: state.loader.wishListLoading,
	locale: state?.intl?.locale,
	dynamicLanguageData: state?.dynamicListSettings?.data,
	dynamicTitle: state?.dynamicListTitles?.data?.dynamicListTitle
});

const mapDispatch = {
	openAddWishListGroupModal,
	deleteWishListGroup,
	closeWishListModal
};

EditWishListComponent.propTypes = {
	data: PropTypes.shape({
		loading: PropTypes.bool,
		getWishListGroup: PropTypes.any
	}),
};

EditWishListComponent.defaultProps = {
	data: {
		loading: true
	},
}

export default compose(
	withStyles(cs, s),
	connect(mapState, mapDispatch),
	withQuery(getWishListGroupQuery,
		{
			options: (props) => ({
				variables: {
					profileId: props.profileId,
					id: Number(props.wishListId)
				},
				fetchPolicy: 'network-only',
				ssr: false
			})
		}
	)
)(EditWishListComponent);